import { MoveLeft } from "lucide-react";
import React, { useEffect, useState } from "react";
import api from "./Axios/api";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
function CreatePO() {
  const [voucher, setVoucher] = useState([]);
  const [active, setActive] = useState("INSULATION");

  const userRole = useSelector((state) => state.user.staff_role);
  const currentStaffFacLoc = useSelector((state) => state.user.staff_FacLoc);

  const navigate = useNavigate();

  const branchMapping = {
    "666c0f5ebeca5ab2c65b2c85": "INSULATION",
    "666c0f5ebeca5ab2c65b2c86": "PROJECTS",
    "666c0f5ebeca5ab2c65b2c87": "ROCKFIBRE",
  };
  const buttons =
    userRole === "666c0f8ebeca5ab2c65b35a9"
      ? ["INSULATION", "PROJECTS", "ROCKFIBRE"]
      : [branchMapping[currentStaffFacLoc]].filter(Boolean);

  const getVoucher = async () => {
    try {
      const res = await api.get("voucher-type/get");
      // console.log(res.data);
      setVoucher(res.data);
    } catch (error) {
      console.log(`Voucher api fetching error...`, error);
    }
  };

  useEffect(() => {
    getVoucher();
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <div className="flex-1 px-5 w-full justify-center items-center">
      <div className="px-2 py-4 rounded-md bg-[#fdfdfd] shadow my-2">
        <div className="flex flex-row justify-between items-center w-full px-3 gap-4 mb-2">
          <div className="text-lg text-violet-500 font-bold">
            PO Voucher List
          </div>
          <div className="flex flex-wrap gap-3">
            {buttons.map((btn) => (
              <button
                key={btn}
                onClick={() => setActive(btn)}
                className={`px-6 py-1 rounded hover:bg-gradient-to-br focus:outline-none ${
                  active === btn
                    ? "bg-[#7C3AED] text-white  bg-gradient-to-r from-violet-500 via-violet-600 to-violet-700"
                    : "bg-[#EEEDEB]"
                }`}
              >
                <span className="text-base">{btn}</span>
              </button>
            ))}

            <button
              className={`flex items-center gap-1 px-5 py-1 rounded text-sm font-medium bg-[#7C3AED] text-white  bg-gradient-to-r from-violet-500 via-violet-600 to-violet-700 hover:bg-gradient-to-br focus:outline-none  text-center`}
              onClick={handleBackClick}
            >
              <MoveLeft size={20} />
              Back
            </button>
          </div>
        </div>
        <div className="w-full min-h-svh py-4 px-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {voucher
              .filter((item) =>
                active === "ALL"
                  ? true
                  : branchMapping[item.voucher_factory] === active
              )
              .map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded p-6 border cursor-pointer hover:border-violet-700 transition-colors duration-300"
                  onClick={() =>
                    navigate(
                      `/created-po-list/${item._id}/${item.voucher_factory}`
                    )
                  }
                >
                  <h3 className="text-lg font-semibold text-gray-800 mb-2 text-center">
                    {item.voucher_type}
                  </h3>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePO;
